// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_WzJ","cls2":"AutoCompleteResults-cls2_2GD AutoCompleteResults-cls1_WzJ","show":"AutoCompleteResults-show_oFD"};